<div class="inner">
    <div class="content"
         [elementHeight]="uid">
        <ng-content />
    </div>
</div>